import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const SearchIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
  </svg>
);
const HomeIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
  </svg>
);
const NewIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
  </svg>
);
const RadioIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H5.43L3.24 6.15zM11 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm7-12h-2v2h-2v-2H6V6h5.44L4.42 0 2.99 1.39 5.43 4H2C.9 4 0 4.89 0 6v14c0 1.11.9 2 2 2h1v-2H2V6h3v2h2V6h6v2h2V6h2v2z"/>
    <circle cx="11" cy="17" r="1"/>
  </svg>
);
const RecentIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
  </svg>
);
const MusicIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 3v10.55A4 4 0 1014 17V7h4V3h-6z"/>
  </svg>
);
const PlaylistIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18A2.99 2.99 0 0016 14c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3V8h3V6h-5z"/>
  </svg>
);

function SbItem({ icon, label, active, onClick }) {
  return (
    <button className={`sb-item ${active ? 'active' : ''}`} onClick={onClick}>
      {icon}{label}
    </button>
  );
}

export default function Sidebar({ onNavigate }) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const view = params.get('view');

  const isHome = pathname === '/' && !view;
  const isView = (v) => pathname === '/' && view === v;

  const go = (v) => { navigate(v ? `/?view=${v}` : '/'); onNavigate?.(); };

  return (
    <aside className="sidebar">

      {/* Search */}
      <div className="sb-search-row">
        <div className="sb-search">
          <SearchIcon />
          <input placeholder="Search music…" onKeyDown={(e) => {
            if (e.key === 'Enter' && e.target.value.trim())
              navigate(`/?view=search&q=${encodeURIComponent(e.target.value.trim())}`);
          }} />
        </div>
      </div>

      {/* Logo */}
      <div className="sb-logo-row">
        <Link to="/" className="sb-logo">
          <img src="/shrifm.png" alt="Shri FM" className="sb-logo-img" />
          <span className="sb-logo-text">Shri<span>FM</span></span>
        </Link>
      </div>

      {/* Main nav */}
      <div className="sb-section">
        <SbItem icon={<HomeIcon />}  label="Home"   active={isHome}          onClick={() => go(null)} />
        <SbItem icon={<NewIcon />}   label="New"    active={isView('new')}   onClick={() => go('new')} />
        <SbItem icon={<RadioIcon />} label="Radio"  active={isView('radio')} onClick={() => go('radio')} />
      </div>

      <div className="sb-divider" />

      <div className="sb-section-label">Library</div>
      <div className="sb-section">
        <SbItem icon={<RecentIcon />} label="Recently Added" active={isView('recent')} onClick={() => go('recent')} />
        <SbItem icon={<MusicIcon />}  label="All Music"      active={isView('music')}  onClick={() => go('music')} />
      </div>

      <div className="sb-divider" />

      <div className="sb-section-label">Playlists</div>
      <div className="sb-section">
        <SbItem icon={<PlaylistIcon />} label="All Music" active={isView('music')} onClick={() => go('music')} />
      </div>

      <div style={{ flex: 1 }} />

      <div className="sb-user-row">
        <div className="sb-user-avatar">FM</div>
        <span className="sb-user-name">Shri FM</span>
      </div>

    </aside>
  );
}
